/* PearlPup - chovani vlastnich sekci (nacita se z kazde gr- sekce, proto guard). */
(function () {
  if (window.__grInit) return;
  window.__grInit = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  // castky jsou v mene trhu zakaznika (Shopify.currency.active), formatovat podle ni
  const money = (c, cur) => {
    const code = cur || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    const loc = { CZK: 'cs-CZ', PLN: 'pl-PL', EUR: 'de-DE', DKK: 'da-DK', SEK: 'sv-SE', NOK: 'nb-NO', CHF: 'de-CH' }[code] || 'en-US';
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: code, currencyDisplay: code === 'USD' ? 'symbol' : 'narrowSymbol' }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' ' + code; }
  };

  function announce() {
    $$('.gr-ann').forEach((bar) => {
      const msgs = $$('.gr-ann__msg', bar);
      if (msgs.length < 2) return;
      let i = 0;
      const show = (n) => { i = (n + msgs.length) % msgs.length; msgs.forEach((m, k) => m.classList.toggle('is-on', k === i)); };
      $('[data-prev]', bar)?.addEventListener('click', () => show(i - 1));
      $('[data-next]', bar)?.addEventListener('click', () => show(i + 1));
      setInterval(() => show(i + 1), 4500);
    });
  }

  function pdp(root) {
    const cfg = JSON.parse($('[data-gr-cfg]', root).textContent);
    // galerie: tecky na mobilu
    const gal = $('.gr-gal', root);
    const dots = $$('.gr-gal__dots i', root);
    gal?.addEventListener('scroll', () => {
      const i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('on', k === i));
    }, { passive: true });

    // --- Desktop thumbnails ---
    const thumbs = $$('.gr-thumbs__btn', root);
    const galImgs = $$('.gr-gal img', root);
    if (thumbs.length > 0 && window.innerWidth >= 990) {
      // On desktop, show only first image initially
      galImgs.forEach((img, i) => { img.classList.toggle('is-main', i === 0); img.loading = 'eager'; });

      thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = +btn.dataset.grThumb;
          thumbs.forEach((t) => t.classList.remove('is-on'));
          btn.classList.add('is-on');
          galImgs.forEach((img, i) => {
            img.classList.toggle('is-main', i === idx);
          });
        });
      });
    }

    // mnozstvi + doplnky -> cena na tlacitku
    let qty = 1;
    const qEl = $('.gr-qty span', root);
    const atc = $('.gr-atc', root);
    const paint = () => {
      let total = cfg.price * qty;
      $$('.gr-bndl__up input:checked, .gr-add input:checked', root).forEach((cb) => { total += +cb.dataset.price; });
      qEl.textContent = qty;
      atc.textContent = `${cfg.label} · ${money(total)}`;
      
    };
    $('[data-minus]', root).addEventListener('click', () => { qty = Math.max(1, qty - 1); paint(); });
    $('[data-plus]', root).addEventListener('click', () => { qty = Math.min(10, qty + 1); paint(); });
    root.addEventListener('change', (e) => { if (e.target.closest('.gr-add')) paint(); });
    paint();


    // --- Bundle selector (Kaching style) ---
    const bndlWrap = $('[data-gr-bundle]', root);
    if (bndlWrap) {
      const bars = $$('[data-gr-bar]', root);
      bars.forEach((bar) => {
        bar.addEventListener('click', (e) => {
          if (e.target.closest('.gr-bndl__up')) return;
          bars.forEach((b) => b.classList.remove('is-sel'));
          bar.classList.add('is-sel');
          const upsEl = $('[data-gr-ups]', root);
          if (upsEl && upsEl.parentNode !== bar) bar.appendChild(upsEl);
          cfg.variant = +bar.dataset.vid;
          window.fsStickySync && window.fsStickySync(bar);
          cfg.price = +bar.dataset.price;
          const priceEl = $('.gr-price', root);
          if (priceEl) {
            const cp = +bar.dataset.cp;
            let html = '<b>' + money(cfg.price) + '</b>';
            if (cp > cfg.price) {
              const pct = Math.round((cp - cfg.price) / cp * 100);
              html += ' <s>' + money(cp) + '</s> <em>SAVE ' + pct + '%</em>';
            }
            priceEl.innerHTML = html;
          }
          paint();
        });
      });
      root.addEventListener('change', (e) => {
        if (e.target.closest('.gr-bndl__up')) paint();
      });
    }

    atc.addEventListener('click', async () => {
      atc.disabled = true;
      const items = [{ id: cfg.variant, quantity: qty }];
      const ppProps = window.ppSuitProps && window.ppSuitProps(); if (ppProps) items[0].properties = ppProps; /* pp: kusy v Buy 2/3 */
      $$('.gr-bndl__up input:checked, .gr-add input:checked', root).forEach((cb) => items.push({ id: +cb.value, quantity: 1 }));
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error((await r.json()).description || 'Error');
        atc.disabled = false;
        if (window.grDrawer) window.grDrawer.open(); else location.href = cfg.after || '/cart';
      } catch (err) {
        alert(err.message);
        atc.disabled = false;
      }
    });

    // sticky lista: jediny prah = hlavni tlacitko odscrollovane nahoru (bez blikani)
    const sticky = $('.gr-sticky', root);
    if (sticky && 'IntersectionObserver' in window) {
      const upd = () => sticky.classList.toggle('is-on', atc.getBoundingClientRect().bottom < 0);
      document.addEventListener('scroll', upd, { passive: true, capture: true });
      addEventListener('resize', upd);
      new IntersectionObserver(upd).observe(atc);
      upd();
      $('[data-gr-sticky-atc]', root)?.addEventListener('click', () => atc.click());
      // presun pod body: nadrazene prvky Horizonu by jinak menily ukotveni position:fixed
      sticky.classList.add('gr');
      document.body.appendChild(sticky);
    }

    // before / after posuvnik
    $$('.gr-ba', root).forEach((ba) => {
      const set = (clientX) => {
        const r = ba.getBoundingClientRect();
        const x = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
        ba.style.setProperty('--x', x + '%');
      };
      let drag = false;
      ba.addEventListener('pointerdown', (e) => { drag = true; ba.setPointerCapture(e.pointerId); set(e.clientX); });
      ba.addEventListener('pointermove', (e) => { if (drag) set(e.clientX); });
      ba.addEventListener('pointerup', () => { drag = false; });
    });
  }

  // ---------- vysouvaci kosik ----------
  const TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg>';
  const esc = (s) => String(s).replace(/&amp;/g, '&').replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  function drawer() {
    const dr = $('[data-gr-drawer]');
    if (!dr) return null;
    const ups = JSON.parse($('[data-gr-upsells]')?.textContent || '[]');
    const addonIds = new Set(ups.map((u) => +u.id));
    const cmp = JSON.parse($('[data-gr-cmp]')?.textContent || '{}');
    const was = (it) => Math.max(it.original_price, cmp[it.variant_id] || 0);
    const grOrphan = (cart) => cart.items.length > 0 && cart.items.every((i) => addonIds.has(i.variant_id));
    const grFix = (cart) => { const updates = {}; cart.items.forEach((i) => { if (addonIds.has(i.variant_id)) updates[i.key] = 0; }); return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) }).then((r) => r.json()); };
    const api = async (url, body) => {
      dr.classList.add('is-busy');
      try {
        const r = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : undefined);
        const j = await r.json();
        if (!r.ok) throw new Error(j.description || j.message || 'Error');
        return j;
      } finally { dr.classList.remove('is-busy'); }
    };
    const render = (cart) => {
      if (grOrphan(cart)) { grFix(cart).then(render).catch(() => {}); }
      $('.gr-dr__count', dr).textContent = cart.items.reduce((n, it) => n + (+(($('[data-fs-protect-input]', dr) || {}).dataset || {}).id === it.variant_id ? 0 : it.quantity), 0);
      $$('.cart-bubble__text-count, [data-testid="cart-bubble"] span').forEach((el) => (el.textContent = cart.item_count));
      const items = $('.gr-dr__items', dr);
      const pIn = $('[data-fs-protect-input]', dr), pid = pIn ? +pIn.dataset.id : 0, pBox = $('[data-fs-protect]', dr);
      const shown = cart.items.filter((it) => it.variant_id !== pid);
      if (pIn) { pIn.checked = cart.items.some((it) => it.variant_id === pid); pBox.hidden = !shown.length; }
      items.innerHTML = shown.map((it) => `
        <div class="gr-dr__item" data-key="${it.key}">
          <span class="gr-dr__media"><img src="${it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=200' : ''}" alt="">${was(it) > it.final_price ? `<em class="gr-dr__off">SAVE ${Math.round((1 - it.final_price / was(it)) * 100)}%</em>` : ''}</span>
          <div>
            <h4>${esc(it.product_title)}</h4>
            ${it.variant_title ? `<span class="gr-dr__vt">${esc(it.variant_title)}</span>` : ''}${it.properties ? Object.keys(it.properties).filter((k) => k[0] !== '_' && it.properties[k]).map((k) => `<span class="gr-dr__vt">${esc(k)}: ${esc(it.properties[k])}</span>`).join('') : ''}<div class="pr">${money(it.final_price)}${was(it) > it.final_price ? ` <s>${money(was(it))}</s>` : ''}${was(it) > it.final_price ? `<br><em class="gr-dr__off">SAVE ${Math.round((1 - it.final_price / was(it)) * 100)}%</em>` : ''}${it.variant_options && it.variant_options[0] !== 'Default Title' ? '' : ''}</div>
            <div class="gr-dr__ctl">
              <div class="gr-dr__qty"><button type="button" data-q="-1" aria-label="Decrease">&minus;</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="Increase">+</button></div>
              <button type="button" class="gr-dr__del" data-del aria-label="Remove">${TRASH}</button>
            </div>
          </div>
          <div class="line">${money(it.final_line_price)}${was(it) > it.final_price ? `<s>${money(was(it) * it.quantity)}</s>` : ''}</div>
        </div>`).join('');
      const inCart = new Set(cart.items.map((i) => i.variant_id));
      const list = ups.filter((u) => !inCart.has(u.id) && u.id !== pid);
      $('.gr-dr__up', dr).hidden = !list.length || !cart.items.length;
      $('.gr-dr__uplist', dr).innerHTML = list.map((u) => `
        <div class="gr-dr__upi"><img src="${u.img}" alt=""><div><b>${esc(u.title)}</b><small>${esc(u.sub)}</small></div>
        <button type="button" data-up="${u.id}">+ ${money(u.price)}</button></div>`).join('');
      $('.gr-dr__empty', dr).hidden = cart.items.length > 0;
      window.fsShipBar && window.fsShipBar(dr, cart.items.length ? cart.total_price : null);
      $('.gr-dr__total b', dr).textContent = `${money(cart.total_price)} ${cart.currency}`;
      // fs-code: kod z popupu (PUP15) viditelne v kosiku
      const codeAmt = (cart.cart_level_discount_applications || []).filter((d) => d.type === 'discount_code')
        .reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
      const codeName = ((cart.cart_level_discount_applications || []).find((d) => d.type === 'discount_code') || {}).title || '';
      let cb = $('.fs-code', dr);
      if (!cb) { cb = document.createElement('div'); cb.className = 'fs-code'; cb.hidden = true; const s0 = $('.gr-dr__save', dr); if (s0) s0.before(cb); }
      cb.hidden = !(codeAmt > 0 && cart.items.length);
      if (!cb.hidden) cb.innerHTML = `<span class="fs-code__i">🎁</span><span class="fs-code__t"><b>${esc(codeName)} applied ✓</b><small>Extra 15% off on top of the Winter Sale</small></span><b class="fs-code__v">-${money(codeAmt)}</b>`;
      const saved = cart.items.reduce((s, it) => s + Math.max(0, was(it) * it.quantity - it.final_line_price), 0) + codeAmt;
      const sv = $('.gr-dr__save', dr);
      if (sv) { sv.hidden = !(saved > 0 && cart.items.length); $('b', sv).textContent = money(saved); }
      const note = $('.gr-dr__note', dr), fsb = $('[data-fs-fsb]', dr);
      if (note) { note.dataset.orig = note.dataset.orig || note.textContent;
        note.textContent = fsb && !fsb.hidden && fsb.classList.contains('is-done') ? 'Duties and taxes included. Free shipping included.' : note.dataset.orig; }
      $('.gr-dr__co', dr).style.display = cart.items.length && !grOrphan(cart) ? '' : 'none';
      const codes = cart.discount_codes || [];
      $('.gr-dr__discmsg', dr).textContent = codes.length ? codes.map((c) => `${c.code}: ${c.applicable ? 'applied' : 'not applicable'}`).join(', ') : '';
    };
    const refresh = async () => render(await api('/cart.js'));
    fetch('/cart.js').then((r) => r.json()).then((c) => { if (grOrphan(c)) return grFix(c).then(render); }).catch(() => {});
    const open = async () => {
      dr.hidden = false;
      await refresh().catch(() => {});
      requestAnimationFrame(() => dr.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      dr.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => (dr.hidden = true), 350);
    };
    dr.addEventListener('click', async (e) => {
      if (e.target.closest('[data-gr-close]')) return close();
      const row = e.target.closest('.gr-dr__item');
      try {
        if (row && e.target.closest('[data-q]')) {
          const q = +$('.gr-dr__qty span', row).textContent + +e.target.closest('[data-q]').dataset.q;
          render(await api('/cart/change.js', { id: row.dataset.key, quantity: Math.max(0, q) }));
        } else if (row && e.target.closest('[data-del]')) {
          render(await api('/cart/change.js', { id: row.dataset.key, quantity: 0 }));
        } else if (e.target.closest('[data-up]')) {
          await api('/cart/add.js', { items: [{ id: +e.target.closest('[data-up]').dataset.up, quantity: 1 }] });
          await refresh();
        } else if (e.target.closest('[data-gr-disc]')) {
          const code = $('.gr-dr__discin input', dr).value.trim();
          if (code) render(await api('/cart/update.js', { discount: code }));
        }
      } catch (err) { alert(err.message); }
    });
    dr.addEventListener('change', async (e) => {
      const pIn = e.target.closest('[data-fs-protect-input]');
      if (!pIn) return;
      const box = pIn.closest('[data-fs-protect]');
      if (box) box.classList.add('is-busy');
      try {
        if (pIn.checked) await api('/cart/add.js', { items: [{ id: +pIn.dataset.id, quantity: 1 }] });
        else {
          const c = await api('/cart.js');
          const it = c.items.find((i) => i.variant_id === +pIn.dataset.id);
          if (it) await api('/cart/change.js', { id: it.key, quantity: 0 });
        }
        await refresh();
      } catch (err) { pIn.checked = !pIn.checked; }
      if (box) box.classList.remove('is-busy');
    });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !dr.hidden) close(); });
    // ikona kosiku v hlavicce otevre nas kosik
    const onCartClick = (e) => {
      const t = e.target.closest('a[href$="/cart"], cart-icon, [on\\:click*="cart-drawer"], .header-actions__cart-icon, [data-testid="cart-drawer-trigger"], button[aria-label*="Cart" i], a[aria-label*="Cart" i]');
      if (!t || dr.contains(t)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    };
    window.addEventListener('click', onCartClick, true);

    // docasny externi checkout (PuzzleHut) - cart permalink se stejnymi polozkami
    const ext = (() => { try { return JSON.parse($('[data-gr-ext-checkout]')?.textContent || '{}'); } catch (e) { return {}; } })();
    if (ext.base && ext.map) {
      const goExt = async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const cart = await api('/cart.js');
        const parts = cart.items.map((i) => ext.map[String(i.variant_id)] ? `${ext.map[String(i.variant_id)]}:${i.quantity}` : null).filter(Boolean);
        if (!parts.length) return;
        location.href = `${ext.base}/cart/${parts.join(',')}`;
      };
      window.addEventListener('click', (e) => {
        if (e.target.closest('.gr-dr__co, a[href$="/checkout"], [name="checkout"], button[form*="cart"][name="checkout"]')) goExt(e);
      }, true);
      window.addEventListener('submit', (e) => {
        if (e.submitter && e.submitter.name === 'checkout') goExt(e);
      }, true);
    }
    // pojistka: kdyby se otevrel puvodni kosik Horizonu, hned ho zavrit (jinak by neviditelny modal blokoval stranku)
    const hz = document.querySelector('#cart-drawer dialog');
    if (hz) {
      new MutationObserver(() => {
        if (hz.open) {
          try { hz.close(); } catch (e) {}
          document.querySelector('#cart-drawer')?.removeAttribute('open');
          document.documentElement.style.overflow = dr.hidden ? '' : 'hidden';
          if (dr.hidden) open();
        }
      }).observe(hz, { attributes: true, attributeFilter: ['open'] });
    }
    return { open, close, refresh };
  }

  const boot = () => { window.grDrawer = drawer(); announce(); $$('[data-gr-pdp]').forEach(pdp); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* fs-sticky-promo */
(function () {
  const money = (c) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
  };
  window.fsStickySync = (bar) => {
    const st = document.querySelector('.gr-sticky');
    if (!st || !bar) return;
    const name = st.querySelector('[data-fs-st-name]'), pr = st.querySelector('[data-fs-st-price]'), cp = st.querySelector('[data-fs-st-cp]');
    if (name && bar.dataset.title) name.textContent = bar.dataset.title;
    if (pr) pr.textContent = money(+bar.dataset.price);
    if (cp) { const c = +bar.dataset.cp; cp.hidden = !(c > +bar.dataset.price); cp.textContent = money(c); }
    const bi = bar.querySelector('.gr-bndl__img img'), si = st.querySelector('[data-fs-st-img] img');
    if (bi && si) { si.src = bi.getAttribute('srcset') ? (bi.currentSrc || bi.src) : bi.src; si.removeAttribute('srcset'); } /* pp: po výměně barvy bez srcset bere src */
  };
  const tick = () => {
    const now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
    const s = Math.max(0, Math.floor((end - now) / 1000)), p = (n) => String(n).padStart(2, '0');
    document.querySelectorAll('[data-fs-clock]').forEach((el) => { el.textContent = p(Math.floor(s / 3600)) + ':' + p(Math.floor(s % 3600 / 60)) + ':' + p(s % 60); });
  };
  tick(); setInterval(tick, 1000);
})();

/* fs-ship-bar: doprava zdarma od $40 (castka v mene obchodu, prepocet kurzem) */
(function () {
  const THRESHOLD = 100; /* pp: doprava zdarma vždy */
  const money = (c) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
  };
  window.fsShipBar = (root, cents) => {
    const box = root && root.querySelector('[data-fs-fsb]');
    if (!box) return;
    box.hidden = true; return; /* pp 3. 11.: bar doprava zdarma vypnut (Tomas) */
    if (cents == null) { box.hidden = true; return; }
    box.hidden = false;
    const need = Math.round(THRESHOLD * (+((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1)));
    const left = need - cents;
    box.classList.toggle('is-done', left <= 0);
    box.querySelector('[data-fs-fsb-t]').innerHTML = left <= 0
      ? '&#127881; You unlocked <b>FREE shipping</b>!'
      : 'You are <b>' + money(left) + '</b> away from <b>FREE shipping</b>';
    box.querySelector('[data-fs-fsb-fill]').style.width = Math.min(100, Math.max(4, cents / need * 100)) + '%';
  };
  const pdp = () => {
    const box = document.querySelector('.fs-fsb--pdp');
    if (!box) return;
    const root = box.closest('section') || document;
    const bar = root.querySelector('.gr-bndl__bar.is-sel');
    const qty = +((root.querySelector('.gr-qty span') || {}).textContent || 1);
    let total = (bar ? +bar.dataset.price : 0) * qty;
    root.querySelectorAll('.gr-bndl__up input:checked, .gr-add input:checked').forEach((cb) => { total += +cb.dataset.price || 0; });
    if (total) window.fsShipBar(box.parentNode, total);
  };
  const later = () => setTimeout(pdp, 30);
  document.addEventListener('click', later, true);
  document.addEventListener('change', later, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdp); else pdp();
})();

/* fs-mobile-thumbs: pas nahledu na mobilu ovlada posuvnou galerii */
(function () {
  const init = () => document.querySelectorAll('[data-gr-pdp]').forEach((root) => {
    const gal = root.querySelector('.gr-gal'), strip = root.querySelector('.gr-thumbs');
    if (!gal || !strip || root.__fsMt) return;
    root.__fsMt = true;
    const btns = [...strip.querySelectorAll('.gr-thumbs__btn')];
    const mobile = () => window.innerWidth < 990;
    const mark = (i) => {
      btns.forEach((b, k) => b.classList.toggle('is-on', k === i));
      const b = btns[i];
      if (b) strip.scrollTo({ left: b.offsetLeft - strip.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' });
    };
    btns.forEach((b, i) => b.addEventListener('click', () => {
      if (!mobile()) return;
      gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
      mark(i);
    }));
    let t;
    gal.addEventListener('scroll', () => {
      if (!mobile()) return;
      clearTimeout(t);
      t = setTimeout(() => mark(Math.round(gal.scrollLeft / gal.clientWidth)), 80);
    }, { passive: true });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
